import styled from 'styled-components'
import LazyImage from '../../../components/LazyImage'

export const MenuContainer = styled.div``

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
`

export const ProductCategoryTabs = styled.div`
  display: flex;
  overflow-x: scroll;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.03);
  background: #fff;
  z-index: 1;

  position: sticky;
  position: -webkit-sticky;
  top: ${props => `${props.headerHeight}px`};

  // hide scrollbar
  -ms-overflow-style: none;  // IE 10+
  scrollbar-width: none;  // Firefox
  ::-webkit-scrollbar {
    display: none;  // Safari and Chrome
  }
}
`

export const Tab = styled.div`
  padding: 1rem;
  white-space: nowrap;
  color: ${({ active, theme }) => (active ? theme.color.primary : theme.color.text)};
  border-bottom: 3px solid
    ${({ active, theme }) => (active ? theme.color.primary : 'transparent')};
`

export const EmptyTab = styled(Tab)`
  width: 100px;
`

export const ProductList = styled.div``

export const CategoryLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.color.primary};
  border-bottom: 1px solid ${({ theme }) => theme.color.primary};
  padding: 0.2rem;
`

export const CategoryIcon = styled(LazyImage)`
  width: 40px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;
`

export const CategoryLabel = styled.div`
  color: ${({ theme }) => theme.color.primary};
  font-size: 1.1rem;
`
export const ProductImage = styled(LazyImage)`
  width: 100%;
  height: 100%;
`
